import * as Types from '../../../graphql-types'

import { gql } from '@apollo/client'
import { Content_ProviderCommonFragmentFragmentDoc } from './ContentProviderCommonFragment.generated'
export type Content_ProviderMetadataFragmentFragment = {
  __typename?: 'Content'
  providerMetadata?: {
    __typename?: 'ContentProvider'
    metadata?: any | null
    contentId?: string | null
  } | null
}

export const Content_ProviderMetadataFragmentFragmentDoc = gql`
  fragment Content_ProviderMetadataFragment on Content {
    providerMetadata: contentProvider {
      metadata
      ...Content_ProviderCommonFragment
    }
  }
  ${Content_ProviderCommonFragmentFragmentDoc}
`
